import React, { useState } from "react";
import { Play, Video } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { webcastDays } from "../mock";
import { useReveal } from "../hooks/useReveal";

const Webcasts = () => {
  useReveal();
  const [activeDay, setActiveDay] = useState(0);
  const day = webcastDays[activeDay];

  return (
    <div>
      <PageHeader title="Webcast 2025" crumb="Webcast 2025" subtitle="Watch recorded sessions and presentations from DRS 2025." />

      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-center gap-3 mb-8 reveal">
            <Video className="w-6 h-6 text-brand" />
            <p className="text-slate-600">{day.sessions.length} recorded sessions from {day.day} — {day.date}.</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mb-10 reveal">
            {webcastDays.map((d, i) => (
              <button key={d.day} onClick={() => setActiveDay(i)}
                className={`px-6 py-3 rounded-full font-semibold text-sm transition-all ${activeDay === i ? "bg-brand text-white shadow-lg shadow-brand/25" : "bg-slate-100 text-slate-600 hover:bg-orange-50 hover:text-brand"}`}>
                {d.day}<span className="hidden sm:inline font-normal opacity-80"> · {d.date}</span>
              </button>
            ))}
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {day.sessions.map((s, i) => (
              <div key={i} className="reveal group bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm card-hover">
                {s.videoUrl ? (
                  <div className="relative aspect-video bg-black">
                    <iframe
                      src={s.videoUrl}
                      title={s.title}
                      className="w-full h-full"
                      loading="lazy"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </div>
                ) : (
                  <div className="relative aspect-video bg-slate-200 flex items-center justify-center">
                    <Play className="w-12 h-12 text-slate-400" />
                  </div>
                )}
                <div className="p-5">
                  <h3 className="font-display font-bold text-navy-900 leading-snug text-sm group-hover:text-brand transition-colors">{s.title}</h3>
                  {s.speaker && (
                    <p className="mt-1.5 text-sm text-slate-500">
                      {s.speaker}{s.location ? ` · ${s.location}` : ""}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Webcasts;
